import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const API_URL = config.baseUrl;

// GET review stats
export const getReviewStats = createAsyncThunk(
  "reviewStats/get",
  async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(`${API_URL}/review-stats`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  }
);

// UPDATE review stats
export const updateReviewStats = createAsyncThunk(
  "reviewStats/update",
  async (payload) => {
    const token = localStorage.getItem("token");
    const res = await axios.put(
      `${API_URL}/review-stats`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  }
);

const reviewStatsSlice = createSlice({
  name: "reviewStats",
  initialState: {
    isLoading: false,
    data: {},
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReviewStats.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReviewStats.fulfilled, (state, action) => {
        // console.log("REVIEW STATS API 👉", action.payload);
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getReviewStats.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(updateReviewStats.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateReviewStats.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateReviewStats.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default reviewStatsSlice.reducer;
